/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'number',
    },
    year: {
      type: 'number',
      minimum: 1000,
      maximum: 9999,
    },
    unit: {
      type: 'string',
    },
  },
  required: ['value', 'year', 'unit'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    annual_revenue: valueSchema,
  },
}
